import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomInput from "../TextField/TextFeild";
import { closeEventNotificationModel, sendNotification } from "../../store/slices/eventSlice";

const validationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    body: Yup.string().required("Body is required"),
});

const EXCLUDED_NOTIFICATION_GROUPS = new Set(["radiomax", "radiofx", "radiiofx"]);

const getSelectableStationGroups = (stationGroupString) => {
    const groups = (stationGroupString || "")
        .split(",")
        .map((g) => g.trim())
        .filter(Boolean)
        .filter((g) => !EXCLUDED_NOTIFICATION_GROUPS.has(g.toLowerCase()));
    return [...new Set(groups)];
};

const EventNotificationModel = ({ show}) => {
    const dispatch = useDispatch();
    const { eventId } = useSelector((state) => state.event);
    const user = useSelector((state) => state.auth.user);
    const selectableGroups = getSelectableStationGroups(user?.attributes?.stationGroup);
    const showGroupSelector = selectableGroups.length > 1;

    const hideModel = () => dispatch(closeEventNotificationModel());
   
    const formik = useFormik({
        initialValues: {
            title: '',
            body: '',
            deeplink: '',
            stationGroups: selectableGroups,
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            if (showGroupSelector && (!values.stationGroups || values.stationGroups.length === 0)) {
                formik.setFieldError("stationGroups", "Select at least one StationGroup/App");
                return;
            }
            const submitValues = { ...values };
            console.log(submitValues,'submitValues')
            dispatch(sendNotification({ message: "Notification sent successfully.", payload: {...submitValues, eventId} })).unwrap().then(()=>{
                hideModel();
                formik.resetForm();
            })

        },
    });

    const toggleStationGroup = (group) => {
        const current = formik.values.stationGroups || [];
        const next = current.includes(group)
            ? current.filter((g) => g !== group)
            : [...current, group];
        formik.setFieldValue("stationGroups", next);
    };

    useEffect(() => {
        if (eventId) {
            formik.resetForm();
        }
    }, [eventId]);


    return (
        <Modal show={show} size="md" onHide={hideModel} centered backdrop="static" keyboard={false}>

            <form className="bg-white" onSubmit={formik.handleSubmit} style={{ minWidth: "560px" }}>
                <div className="form-card shadow-none p-3 m-0">
                    <h4 className="my-2">Send Notification</h4>
                    <div className="">
                        <CustomInput
                            label="Subject"
                            id="subject"
                            name="title"
                            value={formik.values.title}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.title && formik.errors.title}
                            required
                        />

                        <CustomInput
                            label="Message"
                            id="message"
                            name="body"
                            value={formik.values.body}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.body && formik.errors.body}
                            required
                        />

                        <CustomInput
                            label="Deep Link (optional)"
                            id="deepLink"
                            name="deeplink"
                            value={formik.values.deeplink}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.deeplink && formik.errors.deeplink}
                        />
                        {showGroupSelector && (
                            <div className="my-3">
                                <label className="mb-2 fw-semibold">StationGroups / Apps</label>
                                <div className="d-flex flex-column gap-1">
                                    {selectableGroups.map((group) => (
                                        <label key={group} className="d-flex align-items-center gap-2">
                                            <input
                                                type="checkbox"
                                                checked={(formik.values.stationGroups || []).includes(group)}
                                                onChange={() => toggleStationGroup(group)}
                                            />
                                            <span>{group}</span>
                                        </label>
                                    ))}
                                </div>
                                {formik.errors.stationGroups ? (
                                    <div className="error-text">{formik.errors.stationGroups}</div>
                                ) : null}
                            </div>
                        )}
                    </div>
                </div>
                <div className="text-right p-3">
                    <div className="button-div ">
                        <button type="button" className="btn btn-outline-danger mx-3" onClick={hideModel}>
                            Close
                        </button>
                        <button type="submit" className="btn btn-secondary" disabled={formik.isSubmitting}>
                            <span>{formik.isSubmitting ? "Sending..." : "Send"}</span>
                        </button>

                    </div>
                </div>
            </form>
        </Modal>
    );
};

export default EventNotificationModel;
